<template lang="pug">
  v-container.pa-5(fluid grid-list-md fill-height)
    v-layout(column)
      v-flex
        v-layout(row)
          v-flex(xs4 d-flex align-center)
            v-icon.pr-2(size="40") swap_vertical_circle
            v-flex
              .headline Travelanium
              .overline Data synchronize
          v-flex(xs8 d-flex justify-end align-center)
            v-btn(@click="$refs.upload.click()")
              input(ref="upload" type="file" @change="onFileSeleceted")
              v-icon(left) cloud_upload
              | UPLOAD

      v-flex
        v-card
          v-card-text
            v-stepper
              v-stepper-header
                v-stepper-step(:complete="state >= STATE.UPLOAD" step="1") Upload
                v-divider
                v-stepper-step(:complete="state >= STATE.PREVIEW" step="2") Preview
                v-divider
                v-stepper-step(:complete="state >= STATE.SYNC" step="3") Sync
                v-divider
                v-stepper-step(:complete="state >= STATE.FINISH" step="4") Finish

      v-flex
        v-card
          v-card-text
            c-form(:headers="headers" :syncing="syncing" @update="settings = arguments[0]" @submit="doSubmit")

      v-flex(fill-height)
        v-card
          v-card-text
            c-table(:headers="headers" :items="items" :selected="settings.column")
</template>

<script>
import Papa from 'papaparse'
import CTable from '@/components/commons/SyncTable'
import CForm from './Form'
import sendTravelaniumUpdate from '@/services/travelanium'

const STATE = {
  UPLOAD: 0,
  PREVIEW: 1,
  SYNC: 2,
  FINISH: 3
}

export default {
  components: {
    CTable,
    CForm
  },
  data () {
    return {
      STATE,
      state: null,
      headers: [],
      items: [],
      settings: {
        column: -1,
        apiHotelId: null,
        apiTokenId: null
      },
      syncing: false
    }
  },
  mounted () {
    this.state = STATE.UPLOAD
  },
  methods: {
    async onFileSeleceted (e) {
      const target = e.target
      if (target.files.length === 0) {
        return
      }

      const file = target.files[0]
      const allows = ['text/csv', 'application/vnd.ms-excel']
      if (allows.indexOf(file.type) === -1) {
        return alert('Please select *.csv file, other formats are not allowed')
      }

      const rows = await this.doReadCSV(file)
      this.headers = rows[0].map((val, idx) => ({ text: val, value: idx }))
      this.items = rows.slice(1).map(row => ({ ...row }))
      this.state = STATE.PREVIEW
    },

    doReadCSV (file) {
      return new Promise((resolve, reject) => {
        Papa.parse(file, {
          complete: (result) => resolve(result.data),
          error: reject
        })
      })
    },

    async doSubmit () {
      this.state = STATE.SYNC
      this.syncing = true

      const data = this.settings
      try {
        for (let idx in this.items) {
          const item = this.items[idx]
          const number = item[data.column]
          const response = await sendTravelaniumUpdate(data.apiHotelId, number, data.apiTokenId)
          this.$set(item, '$status', response.data.code)
        }
        this.doFinish()
      } catch (e) {
        alert(e.toString())
        this.doError()
      }
    },

    doFinish () {
      this.state = STATE.FINISH
      this.syncing = false
    },

    doError () {
      this.state = STATE.PREVIEW
      this.syncing = false
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@uppy/core/dist/style.css'
@import '~@uppy/drag-drop/dist/style.css'

.head
  .layout
    h1
      font-size: 1.2rem

.v-stepper
  box-shadow: none
  background: none
  color: none

  >>> &__header
    height: 42px

  >>> &__step
    padding: 0 24px

.table
  .v-card
    min-height: 100%

    &__text
      min-height: 100%

.v-btn
  input[type='file']
    display: none
</style>
